import { styled } from 'styled-components';

import { RichDetails } from '#/components/RichDetails/RichDetails';
import {
  richDetailsStateClosedClass,
  richDetailsStateOpenClass,
} from '#/components/RichDetails/richDetailsClasses';
import {
  detailsOneWhenClosedMinusOneWhenOpenVar,
  detailsOneWhenClosedZeroWhenOpenVar,
  detailsZeroWhenClosedOneWhenOpenVar,
} from '#/components/RichDetails/richDetailsCssVariables';
import { cssBreakpoints, transition } from '#/theme/theme';

export const AccordionRichDetails = styled(RichDetails)`
  ${detailsOneWhenClosedZeroWhenOpenVar}: 1;
  ${detailsZeroWhenClosedOneWhenOpenVar}: 0;
  ${detailsOneWhenClosedMinusOneWhenOpenVar}: 1;

  &[open] {
    ${detailsOneWhenClosedZeroWhenOpenVar}: 0;
    ${detailsZeroWhenClosedOneWhenOpenVar}: 1;
    ${detailsOneWhenClosedMinusOneWhenOpenVar}: -1;
  }

  &.${richDetailsStateOpenClass} {
    > div:last-of-type {
      transition: ${transition};
      transition-property: transform;
    }
  }

  &.${richDetailsStateClosedClass} {
    > div:last-of-type {
      visibility: hidden;

      @media all and (max-width: ${cssBreakpoints.mdDown}) {
        transform: translateY(-10%);
      }

      @media all and (min-width: ${cssBreakpoints.mdUp}) {
        transform: translateY(-10px);
      }
    }
  }

  > summary {
    list-style-type: none;
  }
`;
